export default __webpack_public_path__ + "static/media/newsImage.0f8de130.jpg";